var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.ifIe?'iechatSite':'chatSite'}},[_c('h1',[_vm._v("广场公告")]),_vm._v(" "),_c('ul',_vm._l((_vm.noticelist),function(item,index){return _c('li',{key:item.con,staticClass:"con",on:{"click":function($event){return _vm.goDetail(index)}}},[_vm._v("\n       【公告】"+_vm._s(item.content)+"\n     ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5844a375","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatPlaza/chatSite.vue
// module id = null
// module chunks = 